export default {
  styleOverrides: {
    root: {
      color: 'inherit',
      font: 'inherit',
    },
  },
};
